var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberFiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23602 15.2C3.62268 15.2 2.38935 14.8067 1.53602 14.02C0.682682 13.2333 0.216016 12.1933 0.136016 10.9H2.61602C2.73602 11.6467 2.98268 12.2067 3.35602 12.58C3.74268 12.9533 4.36268 13.14 5.21602 13.14C6.02935 13.14 6.66268 12.88 7.11602 12.36C7.56935 11.84 7.79602 11.1333 7.79602 10.24C7.79602 9.37333 7.56268 8.68667 7.09602 8.18C6.64268 7.67333 6.01602 7.42 5.21602 7.42C3.94935 7.42 2.95602 7.83333 2.23602 8.66H0.876016L0.996016 0.699999H9.67602V2.8H3.03602L3.01602 6.68C3.70935 5.88 4.73602 5.48 6.09602 5.48C7.40268 5.48 8.46268 5.91333 9.27602 6.78C10.0893 7.64667 10.496 8.81333 10.496 10.28C10.496 11.7867 10.0093 12.9867 9.03602 13.88C8.06268 14.76 6.79602 15.2 5.23602 15.2Z",
    fill: "#344F7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberFiveIcon);
export default __webpack_public_path__ + "static/media/number-five-icon.0bb77bdfc9e744ece3b207c25931c86e.svg";
export { ForwardRef as ReactComponent };